import { render } from "./Applicant.vue?vue&type=template&id=2d4d6a78&scoped=true"
import script from "./Applicant.vue?vue&type=script&lang=js"
export * from "./Applicant.vue?vue&type=script&lang=js"

import "./Applicant.vue?vue&type=style&index=0&id=2d4d6a78&lang=css"
import "./Applicant.vue?vue&type=style&index=1&id=2d4d6a78&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\45\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4d6a78"]])

export default __exports__